import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    // mode: 'history',
    routes: [{
        path: '/',
        component: () => import("@/components/index"),
        meta: {
            title: '邀星科技首页',
        }
    },
    {
        path: '/anti_fake',
        component: () => import("@/components/anti_fake"),
        meta: {
            title: '防伪系统',
        }
    },
    {
        path: '/business_partner',
        component: () => import("@/components/business_partner"),
        meta: {
            title: '合作商家',
        }
    },
    {
        path: '/business_partner_detail',
        component: () => import("@/components/business_partner_detail"),
        meta: {
            title: '合作商家详情',
        }
    },
    {
        path: '/aboutus',
        component: () => import("@/components/aboutus"),
        meta: {
            title: '关于我们',
        }
    },
    {
        path: '/experience',
        component: () => import("@/components/experience"),
        meta: {
            title: '体验资格申请表',
        }
    },
    {
        path: '/find_anti_fake',
        component: () => import("@/components/find_anti_fake"),
        meta: {
            title: '防伪查询',
        }
    },
    {
        path: '/aitool',
        component: () => import("@/components/aitool"),
        meta: {
            title: 'AI工具集',
        }
    },
    {
        path: '/ai_explain',
        component: () => import("@/components/ai_explain"),
        meta: {
            title: 'AI说明',
        }
    },
    {
        path: '/anli',
        component: () => import("@/components/anli"),
        meta: {
            title: '案例展示',
        }
    },
    {
        path: '/anli_detail',
        component: () => import("@/components/anli_detail"),
        meta: {
            title: '案例详情',
        }
    },
    {
        path: '/zixun_detail',
        component: () => import("@/components/zixun_detail"),
        meta: {
            title: '案例详情',
        }
    },
    {
        path: '/fangwei1',
        component: () => import("@/components/fangwei1"),
        meta: {
            title: 'AI工具集',
        }
    },
    {
        path: '/fangwei_step2',
        component: () => import("@/components/fangwei_step2"),
        meta: {
            title: '防伪',
        }
    },
    ]
})